import { Space, Tag } from 'antd';
import React from 'react';
import { formatDateRange } from 'shared/constants/date';
import { dayjs } from 'shared/utils/date';

const SegmentTag = ({ segment, style, showDateRange }) => {
  if (!segment?.id) return null;

  return segment.title ? (
    <Space>
      <Tag color={segment.color} style={{ ...style, borderColor: segment.segmentColor }}>
        {segment.title}
      </Tag>
      {showDateRange && segment.dateRange && <span>{formatDateRange(dayjs, segment.dateRange.period, segment.dateRange.startDate, segment.dateRange.endDate, { week: 'Week' })}</span>}
    </Space>
  ) : null;
};

export default SegmentTag;
